module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head clear"
  }, [_c('div', {
    staticClass: "left",
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle"
    }
  }, [_c('div', {
    staticClass: "banner-img",
    staticStyle: {
      "margin-top": "20px",
      "vertical-align": "middle"
    },
    style: ({
      'background-image': ("url(" + _vm.cIcon + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.cTitle))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm._f("formateTime")(_vm.cStart)) + "-" + _vm._s(_vm._f("formateTime2")(_vm.cEnd)))])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "33px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "src": "http://medcircle.cn/lib/ydt/logo.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72266f1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl2/hdHead/hdHead.vue
// module id = 812
// module chunks = 10